import { FC } from "react";
import { Span } from "utils/styling/typography.styled";
import * as Styled from "./RegisterBanner.styled";
export const RegisterBanner: FC = () => {
  return <Styled.RegisterBannerContainer data-sentry-element="unknown" data-sentry-component="RegisterBanner" data-sentry-source-file="index.tsx">
            <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">🚀Register Now 🔥 Get 10 Gold Free! 💎</Span>
        </Styled.RegisterBannerContainer>;
};